import React from 'react'
import { useParams } from 'react-router-dom'
import SinglePost from '../components/Blog/SinglePost'

function SinglePostPage() {
    const {id} = useParams()
    return (
        <main style={{overflowX: "hidden"}}>
            <div className="container my-4">
                <SinglePost id={id} />
            </div>
        </main>
    )
}
export default SinglePostPage